import * as React from "react";
import Svg, { SvgProps, G, Path, Defs, ClipPath } from "react-native-svg";

const HistoryIcon = (props) => (
  <Svg
    width={20}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M8.554 4.75h1.192V9.5H8.554V4.75ZM4.977 7.125H.207v-4.75H1.4v2.542a9.209 9.209 0 0 1 1.518-2.05 9.43 9.43 0 0 1 1.975-1.54c.72-.42 1.493-.749 2.32-.984A8.976 8.976 0 0 1 9.745 0c.875 0 1.72.111 2.534.334a9.416 9.416 0 0 1 2.282.956c.708.414 1.35.909 1.928 1.484A9.547 9.547 0 0 1 19.285 9.5h-1.193c0-.76-.1-1.494-.298-2.199a8.519 8.519 0 0 0-.838-1.985 8.025 8.025 0 0 0-1.314-1.689 8.686 8.686 0 0 0-1.686-1.298 8.432 8.432 0 0 0-1.993-.845 7.857 7.857 0 0 0-2.217-.297 8.25 8.25 0 0 0-2.338.334 8.266 8.266 0 0 0-2.115.956 8.866 8.866 0 0 0-1.779 1.494A7.542 7.542 0 0 0 2.21 5.937h2.767v1.188Zm4.769 3.563h9.539v1.187h-9.54v-1.188Zm0 3.562h9.539v1.188h-9.54V14.25Zm0 3.563h9.539V19h-9.54v-1.188Zm-8.039-6.096c.224.798.55 1.537.978 2.218.429.68.944 1.28 1.546 1.8.603.519 1.267.952 1.994 1.298a7.795 7.795 0 0 0 2.329.687v1.206a9.88 9.88 0 0 1-2.72-.77 9.61 9.61 0 0 1-2.33-1.466 9.2 9.2 0 0 1-1.797-2.078 9.651 9.651 0 0 1-1.146-2.58l1.146-.315Z"
        fill="#FAA170"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.207)" d="M0 0h19.077v19H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default HistoryIcon;
